import { useMutation } from 'react-admin';
import React from 'react';

export const useDocuments = (resource, recordId, documentsPath, onDataChange) => {
	const [fetchAllDocuments, { data, loading }] = useMutation({
		type: 'getMany',
		resource: `${resource}/${recordId}/${documentsPath}`,
		payload: {},
	});

	React.useEffect(() => {
		fetchAllDocuments();
	}, [fetchAllDocuments]);

	React.useEffect(() => {
		onDataChange && onDataChange(data);
	}, [data, onDataChange]);

	return { data, loading, fetchAllDocuments };
};
